export { default as InducteeHeroContent } from './InducteeHeroContent';